import * as React from "react"

function SvgComponent(props) {
    return (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M10.083 16.706l-4.628-4.63 1.542-1.542 3.086 3.085 6.17-6.171 1.544 1.543-7.714 7.713v.002z"
                fill="#161717"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12zm12 9.818a9.819 9.819 0 110-19.637 9.819 9.819 0 010 19.637z"
                fill="#161717"
            />
        </svg>
    )
}

export default SvgComponent
